module.exports = function getResource(label, vars = []) {
    let resources = {
        chooseLocation: 'Choose a location'
    };
    return resources[label];
};
